import { CryptoCoin } from '../types';

export enum UserExchange {
    ZeroF = '0F',
    ZeroE = '0E',
    ZeroD = '0D',
    ZeroBi = '0Bi',
    ZeroBk = '0Bk',
    Eleveno = '11o',
    ZeroAt = '0At',
    ZeroAr = '0Ar',
    Fourteenm = '14m',
    Toronto = 'TORONTO',
    Venture = 'VENTURE',
    GB = 'GB',
    Bonds = 'BONDS',
}

export enum OrderFilterType {
    Unallocated = 'unallocated',
    Cancelled = 'cancelled',
    Open = 'open',
    Today = 'today',
    Rejected = 'rejected',
    Latest = 'latest',
    Executed = 'executed',
    Cost = 'cost',
}

export enum OrderType {
    Market = 'MARKET',
    Limit = 'LIMIT',
    Stop = 'STOP',
    StopLimit = 'STOP_LIMIT',
    Spread = 'Spread',
    Notional = 'Notional',
    Even = 'Even',
    Credit = 'Credit',
    Debit = 'Debit',
    TrailingStop = 'TRAILING_STOP',
    MarketOnClose = 'MARKET_ON_CLOSE',
}

export enum OrderTransaction {
    Buy = 'BUY',
    BuyToOpen = 'BUY_TO_OPEN',
    BuyToClose = 'BUY_TO_CLOSE',
    BuyToCover = 'BUY_TO_COVER',
    Sell = 'SELL',
    SellToOpen = 'SELL_TO_OPEN',
    SellToClose = 'SELL_TO_CLOSE',
    ShortSell = 'SHORT_SELL',
    Open = 'OPEN',
    Close = 'CLOSE',
}

export enum OrderActualTransaction {
    Buy = 'B',
    Sell = 'S',
    ShortSell = 'SS',
    BuyToCover = 'BC',
    BuyToOpen = 'BTO',
    BuyToClose = 'BTC',
    SellToOpen = 'STO',
    SellToClose = 'STC',
}

export enum OrderMarket {
    Us = 'U',
    Canada = 'C',
}

export enum AccountType {
    Cash = 1,
    Margin = 2,
}

export enum OrderStatus {
    //Orbis statuses
    Place = 'B',
    AcceptedAtTheExchange = 'W',
    Cancelled = 'C',
    Filled = 'E',
    PartiallyFilled = 'P',
    WaitingForCancellation = 'A',
    WaitingForCancelReplace = 'G',
    Rejected = 'R',
    // AXOS statuses
    Pending = 'PENDING',
    PendingAccount = 'PENDING_ACCOUNT',
    PendingPost = 'PENDING_POST',
    Submitted = 'SUBMITTED',
    PendingCancel = 'PENDING_CANCEL',
    Open = 'OPEN',
    Complete = 'COMPLETE',
    Failed = 'FAILED',
    Error = 'ERROR',
    Unknown = 'UNKNOWN',
}

export enum OrderValidity {
    GoodForDay = 'DAY',
    GoodTilCanceled = 'GTC',
    GoodTilDate = 'GTD',
}

export enum OrderMarketTime {
    PreMarket = 'PRE_MARKET',
    CoreMarket = 'CORE_MARKET',
    PostMarket = 'POST_MARKET',
    AllMarket = 'ALL_MARKET',
    PreCoreMarket = 'PRE_CORE',
    PostCoreMarket = 'POST_CORE',
}

export enum ModelReserveType {
    Dollar = 'DOLLAR',
    Percentage = 'PERCENTAGE',
}

export enum ModelFractionalSharePolicy {
    RoundUp = 'RoundUp',
    RoundDown = 'RoundDown',
    Fractional = 'Fractional',
}

export enum AccountStatus {
    Active = 'A',
    Suspended = 'S',
}

export enum AccountClassification {
    Cash = 'CASH',
    Margin = 'MARGIN',
    DayTrader = 'DAY_TRADER',
    IraRolloverAccount = 'IRA_ROLLOVER_ACCOUNT',
    IraTraditional = 'IRA_TRADITIONAL',
    IraRoth = 'IRA_ROTH',
    IraSep = 'IRA_SEP',
    Inventory = 'INVENTORY',
    DVP = 'DVP',
}

export enum QuoteType {
    Realtime = 'REALTIME',
    RealtimeSnapshot = 'REALTIME_SNAPSHOT',
    Delayed = 'DELAYED',
    CBOE1 = 'CBOE1',
    BATS = 'BATS',
    NBBO = 'NBBO',
    CBOE = 'CBOE',
    QuoddEod = 'Quodd_EOD',
    EquiductRealtime = 'Equiduct_Realtime',
    EquiductDelay = 'Equiduct_Delay',
}

export enum PositionType {
    Cash = 1,
    Margin = 2,
    Short = 3,
}

export enum SecurityType {
    Equity,
    Option,
    MutualFund,
    Bond,
    Etf,
    Algo,
}

export enum GroupType {
    Household = 'household',
    Strategy = 'strategy',
    Freeform = 'freeform',
}

export enum TopPositionsType {
    Weight = 'weight',
    Gain = 'gain',
    GainPercent = 'gainPercent',
}

export enum OverExposedType {
    Security = 'Security',
    SecurityType = 'SecurityType',
    // Sector = 'Sector',
    Industry = 'Industry',
}

export enum CorporateActionsType {
    TenderOffer = 'TenderOffer',
    PrivatelyHeld = 'PrivatelyHeld',
    Acquisition = 'Acquisition',
    Dividend = 'Dividend',
    Split = 'Split',
    SymbolChange = 'SymbolChange',
    NameChange = 'NameChange',
    Deletion = 'Deletion',
    Addition = 'Addition',
    Suspension = 'Suspension',
    Merger = 'Merger',
    ExchangeChange = 'ExchangeChange',
    CusipChange = 'CusipChange',
    UnitSplit = 'UnitSplit',
    Conversion = 'Conversion',
    Spinoff = 'Spinoff',
    Other = 'Other',
}

export enum BondTimeRange {
    OneMinute = '1min',
    FifteenMinute = '15min',
    OneDay = '1day',
}

export enum TimeRange {
    OneDay = '1d',
    TwoWeeks = '2w',
    OneMonth = '1m',
    ThreeMonth = '3m',
    SixMonth = '6m',
    SevenMonth = '7m',
    NineMonth = '9m',
    OneYear = '1y',
}

export enum Etf {
    SPY = 'SPY',
    VOO = 'VOO',
    IVV = 'IVV',
    DIA = 'DIA',
}

export enum UserType {
    Advisor = 'RIA',
    Broker = 'BROKER',
    Client = 'CLIENT',
}

export enum UserStatus {
    Established = 'ESTABLISHED',
    PasswordExpired = 'PasswordExpired',
    RequiredPasswordChange = 'RequiredPasswordChange',
    InitialPasswordChange = 'InitialPasswordChange',
    Pending2FA = 'Pending2FA',
}

export enum Sectors {
    Others = 'Others',
}

export enum TradeDestination {
    SingleAccount,
    AveragePriceAccount,
    Model,
}

export enum OrderFillType {
    Any = 'ANY',
    AllOrNone = 'AON',
}

export enum MutualFundUnit {
    Unit,
    Dollar,
}

export enum MutualFundCapitalGains {
    Reinvest = 'Reinvest',
    PayInCash = 'PayInCash',
}

export enum MutualFundDividends {
    Reinvest = 'Reinvest',
    PayInCash = 'PayInCash',
}

export enum TimeInForce {
    FillOrKill = 'FillOrKill',
    ImmediateOrCancel = 'ImmediateOrCancel',
}

export enum CryptoOrderTransaction {
    Buy = 'buy',
    Sell = 'sell',
}
export enum Consensus {
    StrongBuySpace = 'Strong Buy',
    StrongBuy = 'StrongBuy',
    Buy = 'Buy',
    StrongSellSpace = 'Strong Sell',
    StrongSell = 'StrongSell',
    Sell = 'Sell',
    Hold = 'Hold',
    Neutral = 'Neutral',
}

export enum GlobalSectorCode {
    Cyclical = 1,
    Defensive = 2,
    Sensitive = 3,
}

export enum GlobalGroupCode {
    BasicMaterial = 101,
    ConsumerCyclical = 102,
    FinancialServices = 103,
    RealEstate = 104,
    ConsumerDefensive = 205,
    Healthcare = 206,
    Utilities = 207,
    CommunicationServices = 308,
    Energy = 309,
    Industrials = 310,
    Technology = 311,
}

export enum GlobalIndustryCode {
    Agriculture = 10110,
    BuildingMaterials = 10120,
    Chemicals = 10130,
    ForestProducts = 10140,
    MetalsMining = 10150,
    Steel = 10160,
    VehiclesParts = 10200,
    FurnishingsFixturesAppliance = 10220,
    HomebuildingConstruction = 10230,
    ManufacturingApparelFurniture = 10240,
    PackagingContainers = 10250,
    PersonalServices = 10260,
    Restaurants = 10270,
    RetailCyclical = 10280,
    TravelLeisure = 10290,
    AssetManagement = 10310,
    Banks = 10320,
    CapitalMarkets = 10330,
    Insurance = 10340,
    DiversifiedFinancialServices = 10350,
    CreditServices = 10360,
    REITs = 10420,
    BeveragesAlcoholic = 20510,
    BeveragesNonAlcoholic = 20520,
    ConsumerPackagedGoods = 20525,
    Education = 20540,
    RetailDefensive = 20550,
    TobaccoProducts = 20560,
    Biotechnology = 20610,
    DrugManufacturers = 20620,
    HealthcarePlans = 20630,
    HealthcareProvidersServices = 20645,
    MedicalDevicesInstruments = 20650,
    MedicalDiagnosticsResearch = 20660,
    MedicalDistribution = 20670,
    UtilitiesIndependentPowerProducers = 20710,
    UtilitiesRegulatedWater = 20720,
    TelecommunicationServices = 30810,
    MediaDiversified = 30820,
    InteractiveMedia = 30830,
    OilGas = 30910,
    OtherEnergySources = 30920,
    AerospaceDefense = 31010,
    BusinessServices = 31020,
    Conglomerates = 31030,
    Consttruction = 31040,
    FarmHeavyConstructionMachinery = 31050,
    IndustrialDistribution = 31060,
    IndustrialProducts = 31070,
    Transportation = 31080,
    WasteManagement = 31090,
    Software = 31110,
    Hardware = 31120,
    Semiconductors = 31130,
}

export enum GlobalSubIndustryCode {
    BuildingMaterials = 10120010,
    Chemicals = 10130010,
    SpecialtyChemicals = 10130020,
    LumberWoodProduction = 10140010,
    PaperPaperProducts = 10140020,
    Aluminum = 10150010,
    Copper = 10150020,
    OtherIndustrialMetalsMining = 10150030,
    Gold = 10150040,
    Silver = 10150050,
    OtherPreciousMetalsMining = 10150060,
    CokingCoal = 10160010,
    Steel = 10160020,
    AutoTruckDealerships = 10200010,
    AutoManufacturers = 10200020,
    AutoParts = 10200030,
    RecreationalVehicles = 10200040,
    FurnishingsFixturesAppliances = 10220010,
    ResidentialConstruction = 10230010,
    TextileManufacturing = 10240010,
    ApparelManufacturing = 10240020,
    FootwearAccessories = 10240030,
    PackagingContainers = 10250010,
    PersonalServices = 10260010,
    Restaurants = 10270010,
    ApparelRetail = 10280010,
    DepartmentStores = 10280020,
    HomeImprovementRetail = 10280030,
    LuxuryGoods = 10280040,
    InternetRetail = 10280050,
    SpecialtyRetail = 10280060,
    Gambling = 10290010,
    Leisure = 10290020,
    Lodging = 10290030,
    ResortsCasinos = 10290040,
    TravelServices = 10290050,
    AssetManagement = 10310010,
    BanksDiversified = 10320010,
    BanksRegional = 10320020,
    MortgageFinance = 10320030,
    CapitalMarkets = 10330010,
    FinancialDataStockExchanges = 10330020,
    InsuranceLife = 10340010,
    InsurancePropertyCasualty = 10340020,
    InsuranceReinsurance = 10340030,
    InsuranceSpecialty = 10340040,
    InsuranceBrokers = 10340050,
    InsuranceDiversified = 10340060,
    ShellCompanies = 10350010,
    FinancialConglomerates = 10350020,
    CreditServices = 10360010,
    RealEstateDevelopment = 10410010,
    RealEstateServices = 10410020,
    RealEstateDiversified = 10410030,
    ReitHealthcareFacilities = 10420010,
    ReitHotelMotel = 10420020,
    ReitIndustrial = 10420030,
    ReitOffice = 10420040,
    ReitResidential = 10420050,
    ReitRetail = 10420060,
    ReitMortgage = 10420070,
    ReitSpecialty = 10420080,
    ReitDiversified = 10420090,
    BeveragesBrewers = 20510010,
    BeveragesWineriesDistilleries = 20510020,
    BeveragesNonAlcoholic = 20520010,
    Confectioners = 20525010,
    FarmProducts = 20525020,
    HouseholdPersonalProducts = 20525030,
    PackagedFoods = 20525040,
    EducationTrainingServices = 20540010,
    DiscountStores = 20550010,
    FoodDistribution = 20550020,
    GroceryStores = 20550030,
    Tobacco = 20560010,
    Biotechnology = 20610010,
    DrugManufacturersGeneral = 20620010,
    DrugManufacturersSpecialtyGeneric = 20620020,
    HealthcarePlans = 20630010,
    MedicalCareFacilities = 20645010,
    PharmaceuticalRetailers = 20645020,
    HealthInformationServices = 20645030,
    MedicalDevices = 20650010,
    MedicalInstrumentsSupplies = 20650020,
    DiagnosticsResearch = 20660010,
    MedicalDistribution = 20670010,
    UtilitiesIndependentPowerProducers = 20710010,
    UtilitiesRenewable = 20710020,
    UtilitiesRegulatedWater = 20720010,
    UtilitiesRegulatedElectric = 20720020,
    UtilitiesRegulatedGas = 20720030,
    UtilitiesDiversified = 20720040,
    TelecomServices = 30810010,
    AdvertisingAgencies = 30820010,
    Publishing = 30820020,
    Broadcasting = 30820030,
    Entertainment = 30820040,
    InternetContentInformation = 30830010,
    ElectronicGamingMultimedia = 30830020,
    OilGasDrilling = 30910010,
    OilGasEP = 30910020,
    OilGasIntegrated = 30910030,
    OilGasMidstream = 30910040,
    OilGasRefiningMarketing = 30910050,
    OilGasEquipmentServices = 30910060,
    ThermalCoal = 30920010,
    Uranium = 30920020,
    AerospaceDefense = 31010010,
    SpecialtyBusinessServices = 31020010,
    ConsultingServices = 31020020,
    RentalLeasingServices = 31020030,
    SecurityProtectionServices = 31020040,
    StaffingEmploymentServices = 31020050,
    Conglomerates = 31030010,
    EngineeringConstruction = 31040010,
    InfrastructureOperations = 31040020,
    BuildingProductsEquipment = 31040030,
    FarmHeavyConstructionMachinery = 31050010,
    IndustrialDistribution = 31060010,
    BusinessEquipmentSupplies = 31070010,
    SpecialtyIndustrialMachinery = 31070020,
    MetalFabrication = 31070030,
    PollutionTreatmentControls = 31070040,
    ToolsAccessories = 31070050,
    ElectricalEquipmentParts = 31070060,
    AirportsAirServices = 31080010,
    Airlines = 31080020,
    Railroads = 31080030,
    MarineShipping = 31080040,
    Trucking = 31080050,
    IntegratedFreightLogistics = 31080060,
    WasteManagement = 31090010,
    InformationTechnologyServices = 31110010,
    SoftwareApplication = 31110020,
    SoftwareInfrastructure = 31110030,
    CommunicationEquipment = 31120010,
    ComputerHardware = 31120020,
    ConsumerElectronics = 31120030,
    ElectronicComponents = 31120040,
    ElectronicsComputerDistribution = 31120050,
    ScientificTechnicalInstruments = 31120060,
    SemiconductorEquipmentMaterials = 31130010,
    Semiconductors = 31130020,
    Solar = 31130030,
}

export enum IndustryType {
    Sector = 'SECTOR',
    Group = 'GROUP',
    Industry = 'INDUSTRY',
    SubIndustry = 'SUB_INDUSTRY',
}

export enum IndustrySector {
    ConsumerCyclical = 'CONSUMER_DISCRETIONARY',
    ConsumerDefensive = 'CONSUMER_STAPLES',
    Energy = 'ENERGY',
    FinancialServices = 'FINANCIALS',
    Healthcare = 'HEALTH_CARE',
    Technology = 'INFORMATION_TECHNOLOGY',
    BasicMaterial = 'MATERIALS',
    RealEstate = 'REAL_ESTATE',
    CommunicationServices = 'TELECOMMUNICATION',
    Utilities = 'UTILITIES',
    Industrials = 'INDUSTRIALS',
}

export enum EtfBreakdownDuration {
    OneDay = '1d',
    OneWeek = '1w',
    TwoWeeks = '2w',
    OneMonth = '1m',
}

export enum DocumentType {
    All = 'All',
    Form5498 = 'Form5498',
    SDIRA = 'SDIRA',
    Form1099 = 'Form1099',
    Form1099R = 'Form1099R',
    Form1099Q = 'Form1099Q',
    Form1042S = 'Form1042S',
    Form5498_ESA = 'Form5498_ESA',
    AccountStatement = 'AccountStatement',
    FMV = 'FMV',
}

export enum EarningsTime {
    AfterClose = 'AFTER_CLOSE',
    PriorOpen = 'PRIOR_OPEN',
    During = 'DURING',
    Other = 'OTHER',
}

export enum IpoActionOption {
    Recent = 'recent',
    Upcoming = 'upcoming',
    Performance = 'performance',
}

export enum IpoDataSortOption {
    Symbol = 'symbol',
    IpoDate = 'ipo_date',
    OfferPrice = 'offer_price',
    OfferSize = 'offer_size',
    LastPrice = 'last_price',
    PriceChange = 'price_change',
    IpoReturn = 'ipo_return',
    DayOneReturn = 'day_one_return',
}

export enum IpoPerformanceRange {
    OneMonth = '1m',
    ThreeMonth = '3m',
    SixMonth = '6m',
    OneYear = '1y',
}

export enum EtfCommonParam {
    Sponsors = 'Sponsors',
    AssetClasses = 'AssetClasses',
    InverseTypes = 'InverseTypes',
    Categories = 'Categories',
    Sectors = 'Sectors',
    LeverageTypes = 'LeverageTypes',
    SectorCodes = 'SectorCodes',
}

export enum EtfFilterMainOptions {
    Overview = 'Overview',
    ETFScreener = 'ETF Screener',
}

export enum EtfAnyFilterOption {
    Any = '',
}

export enum EtfFilterAssetOptions {
    Any = '',
    Allocation = 'Allocation',
    Alternative = 'Alternative',
    Commodities = 'Commodities',
    InternationalEquity = 'International Equity',
    MunicipalBond = 'Municipal Bond',
    SectorEquity = 'Sector Equity',
    TaxableBond = 'Taxable Bond',
    USEquity = 'U.S. Equity',
}

export enum StockScreenerStockType {
    ETF = 'ETF',
    ADR = 'ADR',
}

export enum EtfBreakdownCategory {
    TopVolume = 'topvolume',
    TopValue = 'topvalue',
    TopChange = 'topchangepc',
    BottomChange = 'bottomchangepc',
}

export enum EtfScreenerSortParams {
    Symbol = 'symbol',
    Last = 'last',
    Change = 'change',
    Volume = 'volume',
    MarketCap = 'marketcap',
    Expense = 'expense',
    Asset = 'asset',
    Sponsor = 'sponsor',
    Category = 'category',
    Leverage = 'leverage',
    CountryPct = 'countrypct',
    ContinentPct = 'countinentpct',
    SectorPct = 'sectorpct',
    Exposure = 'exposure',
}

export enum OptionRadarCategory {
    CallVolCallOiRatios = 'callVolCallOiRatios',
    CallOiPutOiRatios = 'callOiPutOiRatios',
    CallVolPutVolRatios = 'callVolPutVolRatios',
    PutOiCallOiRatios = 'putOiCallOiRatios',
    PutVolCallVolRatios = 'putVolCallVolRatios',
    PutVolPutOiRatios = 'putVolPutOiRatios',
}

export enum OptionRadarOption {
    Call = 'Call',
    Put = 'Put',
}

export enum BankLinkStatus {
    Approved = 'APPROVED',
    Pending = 'PENDING',
    Rejected = 'REJECTED',
    Canceled = 'CANCELED',
    Unknown = 'UNKNOWN',
    HeldForReview = 'HeldForReview',
}

export enum BankAccountType {
    Checking = 'CHECKING',
    Savings = 'SAVINGS',
}
export enum PaidAccountSubtype {
    Checking = 'checking',
    Savings = 'savings',
    Ira = 'ira',
    Student = 'student',
    FourOneK = '401k',
    Mortgage = 'mortgage',
}

export enum MoneyTransferType {
    Deposit,
    Withdraw,
}

export enum TransferStatus {
    Placed = 'PLACED',
    Pending = 'PENDING',
    Sent = 'SENT',
    Canceled = 'CANCELED',
    Rejected = 'REJECTED',
    Complete = 'COMPLETE',
    CancelRequested = 'CANCEL_REQUESTED',
    CancelPending = 'CANCEL_PENDING',
    FundsHeld = 'FUNDS_HELD',
    FundsPosted = 'FUNDS_POSTED',
    FundsPaid = 'FUNDS_PAID',
    SentToBank = 'SENT_TO_BANK',
    PendingPrinting = 'PENDING_PRINTING',
    Void = 'VOID',
    Returned = 'RETURNED',
    StopPayment = 'STOP_PAYMENT',
    Unknown = 'UNKNOWN',
    BeingHeld = 'BEING_HELD',
}

export enum TransfersDirection {
    Outgoing = 'OUTGOING',
    Incoming = 'INCOMING',
}

// FIXME - remove, when backend update docs
export enum MostActiveOrderFilter {
    DollarVolume = 'dollar_volume',
    Volume = 'volume',
    PriceChangePercent = 'price_change_percent',
}

export enum AgreementCode {
    NyseAmex = 'NA',
    DowJones = 'DJ',
    Options = 'O',
    Nasdaq = 'Q',
    SP500 = 'S5',
    Canada = 'CA',
    CboeGlobal = 'BATS',
}

export enum PolicyValuesType {
    Funding = 'funding',
    Trading = 'trading',
    Acat = 'acat',
}

export enum PolicyOnAccount {
    Allow = 'Allow',
    Disallow = 'Disallow',
    AllowWithdrawal = 'AllowWithdrawal',
    AllowBoth = 'AllowBoth',
}

export enum LegalDocumentClassifications {
    Custodial = 'Custodial',
    Funding = 'Funding',
    Banking = 'Banking',
    TermsOfUse = 'TermsOfUse',
}

export const availableCoins: Record<string, CryptoCoin> = {
    BTC: {
        name: 'Bitcoin',
        icon: '₿',
        symbol: 'BTC/USD',
        twitter: 'https://twitter.com/Bitcoin',
        whitepaper: 'https://bitcoin.org/bitcoin.pdf',
        website: 'https://bitcoin.org/en',
        description:
            'Bitcoin (₿) is a decentralized digital currency, without a central bank or single administrator, that can be sent from user to user on the peer-to-peer bitcoin network without the need for intermediaries.Transactions are verified by network nodes through cryptography and recorded in a public distributed ledger called a blockchain. The cryptocurrency was invented in 2008 by an unknown person or group of people using the name Satoshi Nakamoto. The currency began use in 2009 when its implementation was released as open-source software.',
    },
    ETH: {
        name: 'Ethereum',
        icon: 'Ξ',
        symbol: 'ETH/USD',
        twitter: 'https://twitter.com/ethereum',
        whitepaper: 'https://ethereum.org/en/whitepaper',
        website: 'https://ethereum.org/en',
        description:
            'Ethereum is a decentralized, open-source blockchain with smart contract functionality. Ether (ETH or Ξ) is the native cryptocurrency of the platform. Among cryptocurrencies, Ether is second only to Bitcoin in market capitalization.Ethereum was conceived in 2013 by programmer Vitalik Buterin. Additional founders of Ethereum included Gavin Wood, Charles Hoskinson, Anthony Di Iorio and Joseph Lubin. In 2014, development work commenced and was crowdfunded, and the network went live on 30 July 2015. The platform allows anyone to deploy permanent and immutable decentralized applications onto it, with which users can interact. Decentralized finance (DeFi) applications provide a broad array of financial services without the need for typical financial intermediaries like brokerages, exchanges, or banks, such as allowing cryptocurrency users to borrow against their holdings or lend them out for interest. Ethereum also allows for the creation and exchange of NFTs, which are non-interchangeable tokens connected to digital works of art or other real-world items and sold as unique digital property. Additionally, many other cryptocurrencies operate as ERC-20 tokens on top of the Ethereum blockchain and have utilized the platform for initial coin offerings.',
    },
};

export enum TipranksTrendingStocksFilter {
    Analysts = 'analysts',
    Bloggers = 'bloggers',
}

export enum TipranksTrendingStocksTrendingType {
    MostRated = 'most-rated',
    BestRated = 'best-rated',
    WorstRated = 'worst-rated',
}

export enum TipranksAnalystRatingByStockSort {
    Date = 'date',
    Rank = 'rank',
}

export enum ApprovalMethod {
    Plaid = 'PLAID',
    MicroDeposit = 'MICRO_DEPOSIT',
}

export enum AccountHistoryStatus {
    Pending = 'PENDING',
    Paid = 'PAID',
}

export enum RequestCheckWithdrawalDeliveryMethod {
    Standard = 'STANDARD',
    Overnight = 'OVERNIGHT',
}

export enum MarketCapClassification {
    Large = 'Large',
    Mega = 'Mega',
    Micro = 'Micro',
    Mid = 'Mid',
    Nano = 'Nano',
    Small = 'Small',
}

export enum HistoryCashSubType {
    MarginInterest = 'MarginInterest',
    BookkeepingJournalEntry = 'BookkeepingJournalEntry',
    PAndSTradeDate = 'PAndSTradeDate',
    Dividend = 'Dividend',
}

export enum ActivityType {
    MoneyMovements = 'CAA',
    StockActivity = 'STA',
    StockCashDividend = 'DIV',
    Transfer = 'TRA',
    MandatoryCorporateAction = 'MCA',
    StockReceived = 'REC',
    StockDelivered = 'DEL',
    StockSplit = 'SPL',
    ReverseStockSplit = 'SPR',
    BackofficeCashUpdate = 'CAS',
    OptionExpired = 'EXP',
    OptionExercised = 'EXC',
    ShortSell = 'SS',
    BuyToCover = 'BC',
    BuyToOpen = 'BTO',
    BuyToClose = 'BTC',
    SellToOpen = 'STO',
    SellToClose = 'STC',
    FedWireIn = 'FWI',
    FedWireOut = 'FWO',
    AccountTypeChange = 'TPC',
    AccountBalanceAdjustment = 'ADJ',
}

export enum OptionStrategy {
    // Unsupported strategies but could be available in future
    // CoveredCall = 'CoveredCall',
    // LongCallButterfly = 'LongCallButterfly',
    // ShortStrangle = 'ShortStrangle',
    // LongStrangle = 'LongStrangle',
    // ShortCalendarCall = 'ShortCalendarCall',
    // ShortCalendarPut = 'ShortCalendarPut',
    // DiagonalPutBearSpread = 'DiagonalPutBearSpread',
    // OptionRoll = 'OptionRoll',
    // Collar = 'Collar',

    // Current supported option strategies
    SingleLeg = 'SingleLeg',
    Spread = 'Spread',
    BuyWrite = 'BuyWrite',
    ShortStrangle = 'ShortStrangle',
    LongStrangle = 'LongStrangle',
    LongCallSpread = 'LongCallSpread',
    ShortCallSpread = 'ShortCallSpread',
    LongPutSpread = 'LongPutSpread',
    ShortPutSpread = 'ShortPutSpread',
    LongCalendarCallSpread = 'LongCalendarCallSpread',
    LongCalendarPutSpread = 'LongCalendarPutSpread',
    IronCondor = 'IronCondor',
    IronButterfly = 'IronButterfly',
    SyntheticLongStock = 'SyntheticLongStock',
    SyntheticShortStock = 'SyntheticShortStock',
}

export enum AcatTransferType {
    Full = 'Full',
    Partial = 'Partial',
}

export enum AcatTransferStatus {
    Completed = 'Completed',
    Cancelled = 'Cancelled',
    RequestPlaced = 'RequestPlaced',
}

export enum AcatAccountContraType {
    CollegeTaxAdvantage529 = 'COLLEGE_TAX_ADVANTAGE_529',
    PensionPlan401k = 'PENSION_PLAN_401K',
    TaxShelteredAnnuity403B = 'TAX_SHELTERED_ANNUITY_403B',
    Agency = 'AGENCY',
    BankCustody = 'BANK_CUSTODY',
    Beneficiary = 'BENEFICIARY',
    BeneficiaryRothIra = 'BENEFICIARY_ROTH_IRA',
    Corporate = 'CORPORATE',
    CoTrustee = 'CO_TRUSTEE',
    CustodianUgma = 'CUSTODIAN_UGMA',
    DirectRollover = 'DIRECT_ROLLOVER',
    CoverdellIra = 'COVERDELL_IRA',
    Estate = 'ESTATE',
    HealthSavingsAccount = 'HEALTH_SAVINGS_ACCOUNT',
    Ira = 'IRA',
    Joint = 'JOINT',
    MedicalSavingsAccount = 'MEDICAL_SAVINGS_ACCOUNT',
    Other = 'OTHER',
    QuaLiftedProfitSharingPension = 'QUALIFIED_PROFIT_SHARING_PENSION',
    RothIra = 'ROTH_IRA',
    SimpleIra = 'SIMPLE_IRA',
    Sarsep = 'SARSEP',
    Single = 'SINGLE',
    Trust = 'TRUST',
}

export enum PriceType {
    Decimal = 'Decimal',
    Percentage = 'Percentage',
}

export enum BondCouponFrequency {
    Quarterly = 'quarterly',
    SemiAnnual = 'semi_annual',
    AtMaturity = 'at_maturity',
    Annual = 'annual',
    Monthly = 'monthly',
    Zero = 'zero',
}

export enum BondMunicipalType {
    GeneralObligation = 'general_obligation',
    Revenue = 'revenue',
}

export enum StockScreenerExchangeCode {
    InvestorsExchange = 'IEXG',
    NyseArca = 'ARCX',
    NasdaqCapitalMarket = 'XNCM',
    OtherOtc = 'OOTC',
    AmericanStockExchangeAmex = 'XASE',
    Bats = 'BATS',
    NasdaqGlobalSelectMarket = 'XNGS',
    NyStockExchange = 'XNYS',
    Nasdaq = 'XNAS',
    NasdaqGlobalMarket = 'XNMS',
}

export enum StockScreenerCriteria {
    MarketCap = 'market_cap',
    Volume = 'volume',
    StockType = 'stock_type',
    AverageVolume = 'average_volume_30d',
    DividendExDate = 'dividend_ex_date',
    DividendPayDate = 'dividend_pay_date',
    DividendPercent = 'dividend_percent',
    Gap = 'gap',
    Industry = 'industry',
    PeRatio = 'pe_ratio',
    Price = 'price',
    PriceChangePercent = 'price_change_percent',
    Exchange = 'exchange',
}

export enum StockScreenerCriteriaCondition {
    LessThan = 'less_than',
    MoreThan = 'more_than',
    After = 'after',
    Before = 'before',
    Between = 'between',
    Include = 'include',
    Exclude = 'exclude',
}

export enum BondStatus {
    Called = 'called',
    Outstanding = 'outstanding',
    Defaulted = 'defaulted',
    Matured = 'matured',
    Put = 'put',
    Converted = 'converted',
    Funged = 'funged',
    Liquidated = 'liquidated',
    Repair = 'repair',
    Repurchased = 'repurchased',
    Tendered = 'tendered',
    Unknown = 'unknown',
    Restructured = 'restructured',
}

export enum BondType {
    Corporate = 'corporate',
    CD = 'cd',
    Treasury = 'treasury',
    Municipal = 'municipal',
    Government = 'government',
    Agency = 'agency',
}

export enum BondPurpose {
    Pandemic = 'Pandemic',
    WaterSewer = 'Water & Sewer',
    Spinoff = 'Spinoff',
    PrimarySecondaryEducation = 'Primary/Secondary Education',
    Agriculture = 'Agriculture',
    Airports = 'Airports',
    CapitalExpenditure = 'Capital expenditure',
    SeaportMarineTerminals = 'Seaports/Marine Terminals',
    Acquisition = 'Acquisition',
    OtherUtilities = 'Other Utilities',
    NewPublicHousing = 'New Public Housing',
    Veterans = 'Veterans',
    CreditEnhancement = 'Credit Enhancement',
    Other = 'Other',
    PensionFundingRetirement = 'Pension Funding/Retirement',
    GeneralPurposeStockRepurchase = 'General Purpose/Stock Repurchase',
    GeneralPurposePublicImprovements = 'General Purpose/Public Improvements',
    Infrastructure = 'Infrastructure',
    OtherHealthCare = 'Other Health Care',
    RedeemExistingBondsOrSecurities = 'Redeem Existing Bonds or Securities',
    CivicConventionCenters = 'Civic/Convention Centers',
    GovernmentPublicBuildings = 'Government/Public Buildings',
    Recapitalization = 'Recapitalization',
    CapitalExpenditureFinancingExpenses = 'Capital expenditure/Financing expenses',
    EnvironmentalProtectionProjects = 'Environmental Protection Projects',
    OfficeBuildingLtdPartn = 'Office Building/Ltd Partn',
    EnergyEfficiency = 'Energy Efficiency',
    CircularEconomyAdaptedEcoEfficientProducts = 'Circular Economy Adapted/Eco-efficient Products',
    ProductionTechnologiesProcesses = 'Production Technologies/Processes',
    TollRoadsStreetsHighways = 'Toll Roads/Streets/Highways',
    FloodControlStormDrainage = 'Flood Control Storm Drainage',
    LifecareRetirementCenters = 'Lifecare/Retirement Centers',
    CombinedUtilities = 'Combined Utilities',
    AccessToEssentialServices = 'Access to Essential Services',
    PollutionControl = 'Pollution Control',
    StockRepurchase = 'Stock Repurchase',
    MultiFamilyHousing = 'Multi-Family Housing',
    RedevelopLandClearance = 'Redevelop/Land Clearance',
    BudgetaryPurpose = 'Budgetary Purpose',
    SustainableDevelopmentProjects = 'Sustainable Development Projects',
    AffordableBasicInfrastructure = 'Affordable Basic Infrastructure',
    StudentLoans = 'Student Loans',
    ElectricPublicPower = 'Electric & Public Power',
    RepayBankLoanOrBridgeFinancing = 'Repay Bank Loan or Bridge Financing',
    PurchaseOfChargedAssets = 'Purchase of Charged Assets',
    ParkingFacilities = 'Parking Facilities',
    CorrectionalFacilitiesJails = 'Correctional Facilities/Jails',
    CertainFacilitiesCourts = 'Certain Facilities/Courts',
    OtherHousing = 'Other Housing',
    GenderEqualityInHumanDevelopment = 'Gender Equality in Human Development',
    AlternativeEnergy = 'Alternative Energy',
    EligibleSocialExpenditures = 'Eligible Social Expenditures',
    AcquiringAndDistributionOfVaccine = 'Acquiring and distribution of vaccine',
    GeneralPurpose = 'General Purpose',
    EmployeeStockOwnershipPlan = 'Employee stock ownership plan',
    FinancingOfSubordinatedLoan = 'Financing of Subordinated Loan',
    NursingHomes = 'Nursing Homes',
    MergerOrAcquisition = 'Merger or Acquisition',
    Guarantee = 'Guarantee',
    OtherPublicService = 'Other Public Service',
    HigherEducation = 'Higher Education',
    RefinanceFinancingExpenses = 'Refinance/Financing expenses',
    SingleFamilyHousing = 'Single Family Housing',
    OtherEducation = 'Other Education',
    Merger = 'Merger',
    RepayIntercompanyDebt = 'Repay Intercompany Debt',
    CleanTransport = 'Clean Transport',
    SocioeconomicAdvancementAndEmpowerment = 'Socioeconomic Advancement And Empowerment',
    Undisclosed = 'Undisclosed',
    Restructuring = 'Restructuring',
    WorkingCapital = 'Working capital',
    EmploymentGenerationAlleviateUnemployment = 'Employment Generation/Alleviate Unemployment',
    PropertyExpendit = 'Property Expendit (acquisit/development)',
    CommercialPaperBackup = 'Commercial paper backup',
    StadiumSportsComplex = 'Stadium/Sports Complex',
    FacilitatingDevelopmentNewPharmaceuticalProducts = 'Facilitating the development of new pharmaceutical products',
    Sanitation = 'Sanitation',
    SustainableWaterWasteWaterManagement = 'Sustainable Water or Wastewater management',
    CharterSchools = 'Charter Schools',
    FireStationEquipment = 'Fire Station/Equipment',
    GeneralPurposeAcquisition = 'General Purpose/Acquisition',
    RefinanceExitFromBankruptcy = 'Refinance Exit from Bankruptcy',
    TenderOffer = 'Tender Offer',
    SolidWasteResourceRecovery = 'Solid Waste/Resource Recovery',
    Hospitals = 'Hospitals',
    Airlines = 'Airlines',
    DividendOrDistributionToShareholders = 'Dividend or Distribution to Shareholders',
    GreenConstructionBuildings = 'Green Construction/Buildings',
    EligibleGreenProjects = 'Eligible Green Projects',
    LibrariesOrMuseums = 'Libraries or Museums',
    CarbonReductionThroughReforestationAndAvoidedDeforestation = 'Carbon reduction through reforestation and avoided deforestation',
    EducationProgramsEducationProjects = 'E-education programs - Education Projects',
    Telephone = 'Telephone',
    HospitalEquipmentLoans = 'Hospital Equipment Loans',
    ChinaUrbanConstruction = 'China Urban Construction',
    Tunnels = 'Tunnels',
    PoliceStationEquipment = 'Police Station/Equipment',
    MallsShoppingCenters = 'Malls/Shopping Centers',
    GeneralPurposeRefinance = 'General Purpose/Refinance',
    EconomicDevelopment = 'Economic Development',
    IndustrialDevelopment = 'Industrial Development',
    AircraftShipFinance = 'Aircraft & Ship finance',
    GeneralPurposeWorkingCapital = 'General Purpose/Working Capital',
    Irrigation = 'Irrigation',
    Bridges = 'Bridges',
    AquaticBiodiversityConservation = 'Aquatic Biodiversity Conservation',
    SingleMultiFamilyHousing = 'Single/Multi-Family Housing',
    GeneralPurposeEquipmentUpgrade = 'General Purpose/Equipment Upgrade',
    LeaseFinancing = 'Lease financing',
    StudentHousing = 'Student Housing',
    LandPreservation = 'Land Preservation',
    MassRapidTransit = 'Mass/Rapid Transit',
    RenewableEnergyProjects = 'Renewable Energy Projects',
    Theaters = 'Theaters',
    ProjectFinance = 'Project Finance',
    OtherTransportation = 'Other Transportation',
    PrivatePlacementSecurities = 'Private Placement Securities',
    OtherRecreation = 'Other Recreation',
    ClimateChangeAdaptation = 'Climate Change Adaptation',
    PurchaseOfFundingAgreement = 'Purchase of Funding Agreement',
    PrivateSchools = 'Private Schools',
    ParksZoosBeaches = 'Parks/Zoos/Beaches',
    EquipmentUpgradeConstruction = 'Equipment Upgrade/Construction',
    ProductionSupplyOfCannabis = 'Production/Supply of Cannabis',
    Gas = 'Gas',
}

export enum BondSector {
    Sovereign = 'SOVEREIGN',
    Securities = 'SECURITIES',
    OilAndGas = 'OIL AND GAS',
    Airline = 'AIRLINE',
    Telecommunications = 'TELECOMMUNICATIONS',
    Containers = 'CONTAINERS',
    GasAndUtility = 'GAS UTILITY',
    HealthCareSupply = 'HEALTH CARE SUPPLY',
    OilfieldMachineryAndServices = 'OILFIELD MACHINERY AND SERVICES',
    FoodProcessors = 'FOOD PROCESSORS',
    BeverageBottling = 'BEVERAGE/BOTTLING',
    Utilities = 'UTILITIES',
    Manufacturing = 'MANUFACTURING',
    Tobacco = 'TOBACCO',
    HealthCareFacilities = 'HEALTH CARE FACILITIES',
    FinancialServices = 'FINANCIAL SERVICES',
    AutomotiveManufacturer = 'AUTOMOTIVE MANUFACTURER',
    TransportationOther = 'TRANSPORTATION - OTHER',
    TextilesApparelShoes = 'TEXTILES/APPAREL/SHOES',
    Agency = 'AGENCY',
    Publishing = 'PUBLISHING',
    MortgageBanking = 'MORTGAGE BANKING',
    RetailStores = 'RETAIL STORES',
    RealEstateInvestmentTrust = 'REAL ESTATE INVESTMENT TRUST',
    Lodging = 'LODGING',
    CableMedia = 'CABLE/MEDIA',
    Leasing = 'LEASING',
    HomeBuilders = 'HOME BUILDERS',
    Pharmaceuticals = 'PHARMACEUTICALS',
    Railroads = 'RAILROADS',
    ConsumerProducts = 'CONSUMER PRODUCTS',
    VehicleParts = 'VEHICLE PARTS',
    Services = 'SERVICES',
    Gaming = 'GAMING',
    Industrials = 'INDUSTRIALS',
    Restaurants = 'RESTAURANTS',
    GasPipelines = 'GAS PIPELINES',
    Electronics = 'ELECTRONICS',
    Aerospace = 'AEROSPACE',
    MetalsMining = 'METALS/MINING',
    Chemicals = 'CHEMICALS',
    BuildingProducts = 'BUILDING PRODUCTS',
    LifeInsurance = 'LIFE INSURANCE',
    Machinery = 'MACHINERY',
    OfficialAndMuni = 'OFFICIAL AND MUNI',
    PropertyAndCasualtyInsurance = 'PROPERTY AND CASUALTY INSURANCE',
    Leisure = 'LEISURE',
    InformationTech = 'INFORMATION TECHNOLOGY',
    Banking = 'BANKING',
}

export enum BondSpRating {
    AMinus = 'A-',
    APlus = 'A+',
    AA = 'AA',
    AAPlus = 'AA+',
    AAMinus = 'AA-',
    AAA = 'AAA',
    B = 'B',
    BMinus = 'B-',
    BB = 'BB',
    BBPlus = 'BB+',
    BBMinus = 'BB-',
    BBB = 'BBB',
    BBBPlus = 'BBB+',
    BBBMinus = 'BBB-',
    C = 'C',
    CC = 'CC',
    CCC = 'CCC',
    CCCPlus = 'CCC+',
    CCCMinus = 'CCC-',
    D = 'D',
    NR = 'NR',
    SP1 = 'SP-1',
    SP1Plus = 'SP-1+',
    raCCCPlus = 'raCCC+',
}

export enum BondMunicipalState {
    ND = 'ND',
    NV = 'NV',
    OH = 'OH',
    GU = 'GU',
    NY = 'NY',
    Hi = 'HI',
    IN = 'IN',
    NE = 'NE',
    WV = 'WV',
    FL = 'FL',
    AR = 'AR',
    ME = 'ME',
    CT = 'CT',
    SD = 'SD',
    WY = 'WY',
    LA = 'LA',
    MT = 'MT',
    MI = 'MI',
    NJ = 'NJ',
    MP = 'MP',
    UT = 'UT',
    SC = 'SC',
    VI = 'VI',
    DE = 'DE',
    CA = 'CA',
    NH = 'NH',
    OR = 'OR',
    TX = 'TX',
    PR = 'PR',
    MU = 'MU',
    KY = 'KY',
    NM = 'NM',
    MS = 'MS',
    DC = 'DC',
    MO = 'MO',
    NC = 'NC',
    WI = 'WI',
    RI = 'RI',
    OK = 'OK',
    ID = 'ID',
    GA = 'GA',
    MN = 'MN',
    PA = 'PA',
    MD = 'MD',
    AK = 'AK',
    IL = 'IL',
    TN = 'TN',
    WA = 'WA',
    MA = 'MA',
    AL = 'AL',
    IA = 'IA',
    VT = 'VT',
    CO = 'CO',
    AS = 'AS',
    VA = 'VA',
    AZ = 'AZ',
    KS = 'KS',
}

export enum BondQuantityType {
    Par = 'Par',
    Unit = 'Unit',
}
export enum BasicMaterialIndustryCode {
    Agriculture = '10110',
    BuildingMaterials = '10120',
    Chemicals = '10130',
    ForestProducts = '10140',
    MetalsMining = '10150',
    Steel = '10160',
}

export enum ConsumerCyclicalIndustryCode {
    VehiclesParts = '10200',
    FurnishingsFixturesAppliance = '10220',
    HomebuildingConstruction = '10230',
    ManufacturingApparelFurniture = '10240',
    PackagingContainers = '10250',
    PersonalServices = '10260',
    Restaurants = '10270',
    RetailCyclical = '10280',
    TravelLeisure = '10290',
}

export enum FinancialServicesIndustryCode {
    AssetManagement = '10310',
    Banks = '10320',
    CapitalMarkets = '10330',
    Insurance = '10340',
    DiversifiedFinancialServices = '10350',
    CreditServices = '10360',
}

export enum RealEstateIndustryCode {
    RealEstateServices = '10410',
    Reits = '10420',
}

export enum ConsumerDefensiveIndustryCode {
    BeveragesAlcoholic = '20510',
    BeveragesNonAlcoholic = '20520',
    ConsumerPackagedGoods = '20525',
    Education = '20540',
    RetailDefensive = '20550',
    TobaccoProducts = '20560',
}

export enum HealthcareIndustryCode {
    Biotechnology = '20610',
    DrugManufacturers = '20620',
    HealthcarePlans = '20630',
    HealthcareProvidersServices = '20645',
    MedicalDevicesInstruments = '20650',
    MedicalDiagnosticsResearch = '20660',
    MedicalDistribution = '20670',
}

export enum UtilitiesIndustryCode {
    UtilitiesIndependentPowerProducers = '20710',
    UtilitiesRegulated = '20720',
}

export enum CommunicationIndustryCode {
    TelecommunicationServices = '30810',
    MediaDiversified = '30820',
    InteractiveMedia = '30830',
}

export enum EnergyIndustryCode {
    OilGas = '30910',
    OtherEnergySources = '30920',
}

export enum IndustrialsIndustryCode {
    AerospaceDefense = '31010',
    BusinessServices = '31020',
    Conglomerates = '31030',
    Construction = '31040',
    FarmHeavyConstructionMachinery = '31050',
    IndustrialDistribution = '31060',
    IndustrialProducts = '31070',
    Transportation = '31080',
    WasteManagement = '31090',
}

export enum TechnologyIndustryCode {
    Software = '31110',
    Hardware = '31120',
    Semiconductors = '31130',
}

export enum StockScreenerSectorCode {
    BasicMaterial = '101',
    ConsumerCyclical = '102',
    FinancialServices = '103',
    RealEstate = '104',
    ConsumerDefensive = '205',
    Healthcare = '206',
    Utilities = '207',
    CommunicationServices = '308',
    Energy = '309',
    Industrials = '310',
    Technology = '311',
}

export enum BondScreenerCriteria {
    Statuses = 'statuses',
    BankQualified = 'bank_qualified',
    Callable = 'callable',
    Convertible = 'convertible',
    Coupon = 'coupon',
    CouponFrequencies = 'coupon_frequencies',
    Insured = 'insured',
    IssueDate = 'issue_date',
    Maturity = 'maturity',
    MunicipalStates = 'municipal_states',
    MunicipalTax = 'municipal_tax',
    MunicipalTypes = 'municipal_types',
    Purposes = 'purposes',
    Sectors = 'sectors',
    SpRating = 'sp_ratings',
    Tickers = 'tickers',
    CountryCodes = 'country_codes',
    Types = 'types',
}

export enum BondScreenerCriteriaCondition {
    LessThan = 'less_than',
    MoreThan = 'more_than',
    After = 'after',
    Before = 'before',
    Between = 'between',
}

export enum FundScreenerCriteria {
    Assets = 'assets',
    Categories = 'categories',
    Inverse = 'inverse',
    FundType = 'fund_type',
    Leverage = 'leverage',
    Sectors = 'sectors',
    Sponsors = 'sponsors',
    MarketCap = 'market_cap',
}

export enum FundScreenerCriteriaCondition {
    LessThan = 'less_than',
    MoreThan = 'more_than',
    Between = 'between',
}

export enum TopFundsOrderDirection {
    Asc = 'asc',
    Desc = 'desc',
}

export enum TopFundsOrderField {
    Volume = 'volume',
    DollarVolume = 'dollar_volume',
    PriceChangePercent = 'price_change_percent',
}

export enum RecipientBankIdentifier {
    ABA = 'ABA',
    BIC = 'BIC',
}

export enum WireDisbursementType {
    Partial = 'Partial',
    Full = 'Full',
}

export enum BankRelationshipType {
    Wire = 'Wire',
    ACH = 'ACH',
}

export enum Currency {
    UsDollar = 'USD',
    IsraeliNewShekel = 'ILS',
}

export enum AlgoStrategy {
    VWAP = 'VWAP',
    TWAP = 'TWAP',
    POV = 'POV',
}

export enum Fundamentals {
    BalanceSheet = 'balance_sheet',
    CashFlow = 'cash_flow',
    IncomeStatement = 'income_statement',
}

export enum IraContributionType {
    Regular = 'REGULAR',
    Employee = 'EMPLOYEE',
    Employer = 'EMPLOYER',
    Recharacterization = 'RECHARACTERIZATION',
    Rollover60Day = 'ROLLOVER_60_DAY',
    RolloverDirect = 'ROLLOVER_DIRECT',
    Transfer = 'TRANSFER',
    TrusteeFee = 'TRUSTEE_FEE',
    Conversion = 'CONVERSION',
    Repayment = 'REPAYMENT',
}

export enum IraDistributionTaxType {
    Percent = 'Percent',
    Fixed = 'Fixed',
}
export enum IraDistributionReasonType {
    Normal = 'NORMAL',
    Disability = 'DISABILITY',
    Sosepp = 'SOSEPP',
    Premature = 'PREMATURE',
    Death = 'DEATH',
    ExcessContributionRemovalBeforeTaxDeadline = 'EXCESS_CONTRIBUTION_REMOVAL_BEFORE_TAX_DEADLINE',
    ExcessContributionRemovalAfterTaxDeadline = 'EXCESS_CONTRIBUTION_REMOVAL_AFTER_TAX_DEADLINE',
    RolloverToQualifiedPlan = 'ROLLOVER_TO_QUALIFIED_PLAN',
    RolloverToIra = 'ROLLOVER_TO_IRA',
    Transfer = 'TRANSFER',
    RecharacterizationPriorYear = 'RECHARACTERIZATION_PRIOR_YEAR',
    RecharacterizationCurrentYear = 'RECHARACTERIZATION_CURRENT_YEAR',
    Conversion = 'CONVERSION',
    ManagementFee = 'MANAGEMENT_FEE',
    PrematureSimpleIraLessThan2Years = 'PREMATURE_SIMPLE_IRA_LESS_THAN_2_YEARS',
    NormalRothIraGreaterThan5Years = 'NORMAL_ROTH_IRA_GREATER_THAN_5_YEARS',
    PlanLoan401k = 'PLAN_LOAN_401K',
    NetIncomeAttributable = 'NET_INCOME_ATTRIBUTABLE',
    Revocation = 'REVOCATION',
    NonReportable = 'NON_REPORTABLE',
}

export enum AccountCurrencyApproach {
    PerCurrency = 'PerCurrency',
    Equivalent = 'Equivalent',
}
